// src/features/units/pages/UnitsPage.js
import React from 'react';
import MasterDataListPage from '../../master-data/pages/MasterDataListPage';

const UnitsPage = () => {
  return <MasterDataListPage type="units" />;
};

export default UnitsPage;